/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Report_SuccessInputs */

const en_profile_report_success = /** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Report submitted, our team will review this user.`)
};

const es_profile_report_success = /** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reporte enviado, nuestro equipo revisará a este usuario.`)
};

const fr_profile_report_success = /** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signalement soumis, notre équipe examinera cet utilisateur.`)
};

const de_profile_report_success = /** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldung gesendet. Unser Team wird diesen Nutzer überprüfen.`)
};

const id_profile_report_success = /** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan dikirimkan — tim kami akan meninjau pengguna ini.`)
};

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const ja_profile_report_success = en_profile_report_success;

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const zh_profile_report_success = en_profile_report_success;

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const ar_profile_report_success = en_profile_report_success;

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const it_profile_report_success = en_profile_report_success;

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const ru_profile_report_success = en_profile_report_success;

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const pt_profile_report_success = en_profile_report_success;

/** @type {(inputs: Profile_Report_SuccessInputs) => LocalizedString} */
const ko_profile_report_success = en_profile_report_success;

/**
* | output |
* | --- |
* | "Report submitted, our team will review this user." |
*
* @param {Profile_Report_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const profile_report_success = /** @type {((inputs?: Profile_Report_SuccessInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Report_SuccessInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_report_success(inputs)
	if (locale === "es") return es_profile_report_success(inputs)
	if (locale === "fr") return fr_profile_report_success(inputs)
	if (locale === "de") return de_profile_report_success(inputs)
	if (locale === "ja") return ja_profile_report_success(inputs)
	if (locale === "zh") return zh_profile_report_success(inputs)
	if (locale === "ar") return ar_profile_report_success(inputs)
	if (locale === "id") return id_profile_report_success(inputs)
	if (locale === "it") return it_profile_report_success(inputs)
	if (locale === "ru") return ru_profile_report_success(inputs)
	if (locale === "pt") return pt_profile_report_success(inputs)
	return ko_profile_report_success(inputs)
});